import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import {
    IdentityProviderDetails,
    FormattedIdentityProviderDetails
} from "@idw-types/data/identity-providers";
import { injectIdentityProviderId } from "@utils/parameter-injector";
import { EntityStatusTypes } from "../../enums/entity-status-types";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

type UpdateIdentityProviderRequestResponse = {
    transferObject: IdentityProviderDetails;
};

export const updateIdentityProviderRequest = async (
    identityProviderDetails: FormattedIdentityProviderDetails
): Promise<GenericNetworkResponse<UpdateIdentityProviderRequestResponse>> => {
    const route = injectIdentityProviderId(apiRoutes.idpConfiguration.identityProviderConfig.axnAdmin.identityProviderWithId, identityProviderDetails.id);
    const body = {
        category: identityProviderDetails.category.key,
        classificationID: identityProviderDetails.classification.id,
        code: identityProviderDetails.code,
        comments: null as any,
        companyID: identityProviderDetails.company.id,
        companyIDPInfo: {
            authURL: identityProviderDetails.companyIDPInfo.authURL,
            clientID: identityProviderDetails.companyIDPInfo.clientID,
            clientSecret: identityProviderDetails.companyIDPInfo.clientSecret,
            companyIDPAttributeMaps: identityProviderDetails.companyIDPInfo.companyIDPAttributeMaps.map(attr => ({
                attributeTypeID: attr.attributeTypeID,
                fieldType: attr.fieldType,
                idpField: attr.idpField,
                uuid: attr.uuid
            })),
            companyIDPInfoParams: identityProviderDetails.companyIDPInfo.companyIDPInfoParams.map(param => ({
                key: param.key,
                status: EntityStatusTypes.ACTIVE,
                urlType: param.urlType,
                value: param.value,
                uuid: param.uuid
            })),
            id: identityProviderDetails.companyIDPInfo.id,
            idpRedirectURL: identityProviderDetails.companyIDPInfo.idpRedirectURL,
            jwksURL: identityProviderDetails.companyIDPInfo.jwksURL,
            scope: identityProviderDetails.companyIDPInfo.scope,
            status: identityProviderDetails.companyIDPInfo.status,
            tokenAuthScheme: identityProviderDetails.companyIDPInfo.tokenAuthScheme?.scheme,
            tokenURL: identityProviderDetails.companyIDPInfo.tokenURL,
            userCredentialField: identityProviderDetails.companyIDPInfo.userCredentialField,
            userInfoURL: identityProviderDetails.companyIDPInfo.userInfoURL,
            wellKnownURL: identityProviderDetails.companyIDPInfo.wellKnownURL
        },
        id: identityProviderDetails.id,
        idpRedirectURL: identityProviderDetails.companyIDPInfo.idpRedirectURL,
        loa: identityProviderDetails.loa.key,
        name: identityProviderDetails.name,
        protocol: identityProviderDetails.protocol.key,
        status: identityProviderDetails.companyIDPInfo.status
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};